import { render } from "./EntitlementNoMatchModal.vue?vue&type=template&id=39bebef2&scoped=true"
import script from "./EntitlementNoMatchModal.vue?vue&type=script&lang=js"
export * from "./EntitlementNoMatchModal.vue?vue&type=script&lang=js"

import "./EntitlementNoMatchModal.vue?vue&type=style&index=0&id=39bebef2&scoped=true&lang=css"

import exportComponent from "/Users/oscarbout/Code/3birdhrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39bebef2"]])

export default __exports__